import { CustomInput } from 'reactstrap';
import styled from 'styled-components';

const StyledCustomInput = styled(CustomInput)`
  & {
    .custom-control-input ~ .custom-control-label,
    .custom-control-input.is-valid ~ .custom-control-label {
      color: ${props => props.theme.colors.black};
    }

    .custom-control-label::before {
      background-color: ${props => props.theme.colors.white};
    }

    .custom-control-input.is-valid ~ .custom-control-label::before,
    .was-validated .custom-control-input:valid ~ .custom-control-label::before {
      background-color: ${props => props.theme.colors.white};
    }

    &.custom-radio
      .custom-control-input:checked
      ~ .custom-control-label::before {
      background-color: ${props => props.theme.colors.white};
    }

    &.custom-checkbox
      .custom-control-input:checked
      ~ .custom-control-label::before {
      background-color: ${props => props.theme.colors.purple};
    }
  }
`;

export default StyledCustomInput;
